import React, { useEffect } from 'react'

import { useParams } from 'react-router';

const UpgradeAccess = () => {
  const { plan } = useParams();

  useEffect(() => {
    if(plan){
      if(atob(plan) === '1A') {
        window.location.assign('https://cjsuccessteam.convertri.com/va-fe')
      } else if(atob(plan) === '2A') {
        window.location.assign('https://cjsuccessteam.convertri.com/va-oto1')  
      } else if(atob(plan) === '3A') {
        window.location.assign('https://club.vidamaze.io')
      } else if(atob(plan) === '4A') {  
        window.location.assign('https://cjsuccessteam.convertri.com/va-oto3')
      } else if(atob(plan) === '6A') {
        window.location.assign('https://leads.vidamaze.io')
      } else if(atob(plan) === '7A') { 
        window.location.assign('https://cjsuccessteam.convertri.com/va-oto5')
      } else if(atob(plan) === '8A' || atob(plan) === '8B') {
        window.location.assign('https://cjsuccessteam.convertri.com/va-ultimate-bundle-deal')
      }else if(atob(plan) === '8SB') {
        window.location.assign('https://cjsuccessteam.convertri.com/va-super-bundle-offer')
      }
    }

  }, [plan])

  return (
    <>
      
    </>
  )
}

export default UpgradeAccess